import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const AgendaIDIndex = lazy(() => import('./:person/:month/:tab/Index'))

export const CrewWageRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources--crew-wage']}>
    <Route path='wage/:person/:month/:tab/*' element={<AgendaIDIndex admin />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
